import { render } from "./PartsWithAI.vue?vue&type=template&id=062d896d&scoped=true"
import script from "./PartsWithAI.vue?vue&type=script&lang=js"
export * from "./PartsWithAI.vue?vue&type=script&lang=js"

import "./PartsWithAI.vue?vue&type=style&index=0&id=062d896d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062d896d"]])

export default __exports__